export const NOTIFICATION_ERROR = 'error'
export const NOTIFICATION_WARNING = 'warning'
export const NOTIFICATION_INFO = 'info'
export const NOTIFICATION_SUCCESS = 'success'